module.exports = __webpack_public_path__ + "img/thumb_03.b1754e26.jpg";